import { z } from 'zod/v4';

export const FeatureFlagNameRuntype = z.enum([
    'early_quotation_request',
    'risk_management',
    'monitoring_demand',
    'silicon_expert',
    'template_wizard',
    'luminovo_home_page',
    'siliconexpert_component_sync',
    'quotation_builder',
    'data_warehouse',
    'project_progress',
    'pcb_module',
    'manufacturing_drivers_table_v2',
    'is_demand_groups_enabled',
    'pcb_dfm_viewer',
    'manufacturing_scenario_redesign',
    'allow_pcb_reuse',
    'risk_weekly_digest',
    'scope_approved_vendor_list',
    'part_alternative_workflow',
    'lumi_web_search',
    'component_importer_v2',
    'quote_request_excel_attachment_off_by_default',
    'manufacturing_part_data_warnings_legacy',
    'monitoring_page',
    'monitoring_metrics',
    'monitoring_agent',
    'market_savings_report',
    'redirect_savings_report_to_component_pricing',
    'savings_metric',
    'quote_import_combine_price_breaks',
    'z2data',
    'srm_module',
    'customer_portal_routes',
    'new_navigation',
    'negotiations',
    'ignore_quote_request_status',
]);
export type FeatureFlagName = z.infer<typeof FeatureFlagNameRuntype>;
